import { Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the IdomooPlayerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-idomoo-player',
  templateUrl: 'idomoo-player.html',
})
export class IdomooPlayerPage {
  vid: {url:any} = {url:""};
  constructor(public navCtrl: NavController, public navParams: NavParams, private render: Renderer2, private sanitizer: DomSanitizer) {
  	//localStorage.setItem('vid',"https://v.idomoo.com/2474/0000/2471z1zf1s1iw2m13f1rsd01vsn2m1qfbn5.m3u8");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IdomooPlayerPage');
    this.vid.url = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.vid);


/*	let scr : HTMLScriptElement = document.createElement('script');
	scr.type = "text/javascript";
	scr.id = "idomooScript";
	scr.src = "../assets/scripts/idomoo-player.js";

	let dlLink = document.getElementsByClassName('container')[0];
	this.render.appendChild(this.xpand.nativeElement,scr);*/
	//dlLink.insertBefore(scr,dlLink.childNodes[0]);
  }

}



// WEBPACK FOOTER //
// ./src/pages/idomoo-player/idomoo-player.ts